export interface CondicionFiscalOption {
  label: string;
  value: string;
}

const getCondicionesFiscales = (): CondicionFiscalOption[] => {
  let result: CondicionFiscalOption[] = [
    {
      label: "Monotributista",
      value: "Monotributista",
    },
    {
      label: "Responsable Inscripto",
      value: "ResponsableInscripto",
    },
    {
      label: "Iva Exento",
      value: "IvaExento",
    },
  ];

  return result;
};

export default getCondicionesFiscales;
